import { Component, OnInit, Input, EventEmitter, Output } from "@angular/core";
import { CommonModule } from "@angular/common";
import { DomSanitizer } from "@angular/platform-browser";
import { TranslateModule } from "@ngx-translate/core";

@Component({
  selector: "pdf-preview",
  templateUrl: "./pdf-preview.component.html",
  styleUrls: ["./pdf-preview.component.scss"],

  imports: [CommonModule, TranslateModule],
  standalone: true,
})
export class PdfPreviewComponent implements OnInit {
  @Input() pdfUrl: string;
  @Input() docNum: number;
  @Input() docTitle: string;
  @Output() onClose = new EventEmitter();

  constructor(private sanitizer: DomSanitizer) {}

  ngOnInit(): void {}

  getPdfUrl() {
    let url = this.pdfUrl + "#toolbar=1";
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  closePanel() {
    this.onClose.emit();
  }
}
